import { LogoFullLight } from 'app/src/kit/icons/logos'
import { styled } from 'styled-components'
import fieldsImg from '../../images/field-view.webp'

type OfflineLayoutProps = { $headerPosition?: 'top' | 'left' }

const OfflineLayoutContainer = styled(Flex)`
  padding: ${(p) => p.theme.spacings['2xl']}px;
  flex: 1;
  @media only screen and (max-width: 599px) {
    /* styles for phones */
    flex-direction: column;
    padding: ${(p) => p.theme.spacings['lg']}px;
    gap: ${(p) => p.theme.spacings['md']}px;
    overflow-y: auto;
  }
`

const MobileImage = styled.img`
  display: none;
  @media only screen and (max-width: 599px) {
    display: inherit;
    object-fit: cover;
    position: absolute;
    z-index: -1;
    border-radius: 24px;
    height: 100%;
    width: 100%;
  }
`

const FieldView = styled(Flex)`
  align-items: center;
  justify-content: center;

  flex: 1;
  max-width: 1024px;

  background:
    linear-gradient(rgb(0 0 0 / 10%), rgb(0 0 0 / 10%)),
    url(${fieldsImg}) no-repeat center center fixed;
  background-size: cover;

  border-radius: 24px;
  padding: 32px;

  user-select: none;
  user-drag: none;

  @media only screen and (max-width: 599px) {
    background: none;
    flex: 0 1 100px;
    position: relative;
    padding: 40px;
    width: 100%;
    margin-bottom: 20px;
  }
`

const OfflineLayout: FC<OfflineLayoutProps> = ({ children }) => {
  return (
    <OfflineLayoutContainer>
      <FieldView>
        <MobileImage src={fieldsImg} alt='weenat background' />
        <LogoFullLight height={96} />
      </FieldView>
      <Flex $flexDirection='column' $justifyContent='space-around' $flex={1}>
        {children}
      </Flex>
    </OfflineLayoutContainer>
  )
}

export default OfflineLayout
